import { TransportOutput } from '@allocab/allocab-commons-shared-types';

import { t } from '../../../services/translation/translation';
import { CustomSlider } from '../../custom-slider/CustomSlider';

export type TransportPickerType = 'train' | 'flight';

export const getMinimalDelay = (type: TransportPickerType | null, minimalDelay?: number) =>
  minimalDelay != null ? Math.ceil(minimalDelay / 5) * 5 : type === 'train' ? 10 : 20;

type PickupDelayProps = {
  transport: TransportOutput;
  delay: number;
  onDelayUpdated: (_updatedDelay: number) => void;
};

export function PickupDelay({ transport, delay, onDelayUpdated }: PickupDelayProps) {
  const minimumValue = getMinimalDelay(
    transport.type === 'trainstation' ? 'train' : 'flight',
    transport.pickupPoint.minimalDelay,
  );

  const maximumValue = transport.type === 'trainstation' ? 30 : 120;
  return (
    <div>
      <div className="flex flex-row space-x-2">
        <h2 className="text-lg font-bold">
          {t(transport.type === 'trainstation' ? 'pickup-delay.trainstation-time' : 'pickup-delay.airport-time')}
        </h2>
      </div>
      <div>
        {t('pickup-delay.selected-delay')}
        {delay}min
      </div>
      <CustomSlider
        minimumValue={minimumValue}
        maximumValue={maximumValue}
        step={5}
        defaultValue={delay}
        onValueChange={onDelayUpdated}
      />
    </div>
  );
}
